<div>
  <div class="form-modified">
    <div class="error-list m-0" v-if="errors">
      <ul class="error-msg">
        <li v-for="(error,x) in errors" :key="x">
          <div v-for="(err,i) in error" :key="i">
            <p> {{err}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-lg-2 pr-0">
        <div class="inner-v-sidebar h-100">
          <ul class="nav flex-column" id="myTab" role="tablist">
            <li class="nav-item">
              <!-- <p>{{content.id}}</p> -->
              <a class="nav-link active" id="email-tab" data-toggle="tab" href="#email" role="tab" aria-controls="email"
                aria-selected="true">Email setting</a>
              <!-- <p>{{index}}</p> -->
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" id="stripe-tab" data-toggle="tab" href="#stripe" role="tab" aria-controls="stripe"
                aria-selected="true">Stripe setting</a>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="col-lg-10 pl-0">
        <div class="tab-content bg-white p-3 h-100" id="myTabContent">
          <div class="tab-pane fade show active" id="email" role="tabpanel" aria-labelledby="email-tab">
            <EmailSetting></EmailSetting>

          </div>

          <div class="tab-pane fade" id="stripe" role="tabpanel" aria-labelledby="stripe-tab">
            <!-- Wrapper -->
            <div class="setting-wrapper">
              <div class="form-group row">
                <label for="" class="col-lg-2 col-form-label">Key</label>
                <div class="col-lg-5">
                  <input type="text" id="inputPassword" placeholder="Key" class="form-control ">
                </div>
                <div class="col-lg-5">
                  <input type="text" id="inputPassword" placeholder="Key" class="form-control ">
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-lg-2 col-form-label">Api version</label>
                <div class="col-lg-10">
                  <input type="text" id="inputPassword" placeholder="Version 0.00" class="form-control ">
                </div>

              </div>
              <div class="content-block">
                <div class="row">
                  <div class="col-md-10 offset-md-2"><button type="submit" class="btn default-btn">
                      Edit
                    </button> <button type="submit" class="btn default-btn save-btn">
                      Save
                    </button> <button type="submit" class="btn default-btn cancel">
                      Cancel
                    </button></div>
                </div>
              </div>
            </div>
            <!-- Wrapper -->
          </div>

        </div>
      </div>
    </div>
  </div>

</div>